import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../app/store";
import { useAppNotifications } from "../../components/LMNotifications";
import { OrderInfo, OrderTimeline } from "../../modules/orders";
import { fetchOrder } from "../../modules/orders/slice";
import { OrderProducts } from "../../modules/orders/OrderProducts";
import styles from "./Order.module.css";

export const Order = () => {
  const params = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { contextHolder } = useAppNotifications();

  const { selectedOrder } = useSelector((state: RootState) => {
    return state.orders;
  });

  const handleFetchOrderDetails = useCallback(() => {
    if (!params.orderId) return;
    dispatch(fetchOrder({ orderId: params.orderId }));
  }, [params, dispatch]);

  useEffect(() => {
    handleFetchOrderDetails();
  }, [handleFetchOrderDetails]);

  if (!selectedOrder) return null;

  return (
    <div className={styles.container}>
      {contextHolder}
      <div className={styles.content}>
        <OrderInfo order={selectedOrder} />
        <OrderProducts
          orderProducts={selectedOrder.products}
          orderId={selectedOrder.id}
        />
      </div>
      <div className={styles.timeline}>
        <OrderTimeline order={selectedOrder} />
      </div>
    </div>
  );
};
